export default {
  clicks: {
    id: "clicks",
    name: "Clicks",
    type: "count",
    kind: "metric",
    messageId: "LABEL_CLICKS",
  },
  client_margin_share: {
    id: "client_margin_share",
    name: "Client Margin Share",
    type: "money",
    kind: "metric",
    messageId: "LABEL_CLIENT_MARGIN_SHARE",
  },
  client_margin_share_usd: {
    id: "client_margin_share_usd",
    name: "(USD) Client Margin Share",
    type: "money-usd",
    kind: "metric",
    messageId: "LABEL_CLIENT_MARGIN_SHARE_USD",
  },
  platform_access_fee: {
    id: "platform_access_fee",
    name: "Platform Access Fee",
    type: "money",
    kind: "metric",
    messageId: "LABEL_PLATFORM_ACCESS_FEE",
  },
  platform_access_fee_usd: {
    id: "platform_access_fee_usd",
    name: "(USD) Platform Access Fee",
    type: "money-usd",
    kind: "metric",
    messageId: "LABEL_PLATFORM_ACCESS_FEE_USD",
  },
  ctc: {
    id: "ctc",
    name: "CTC",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_CTC",
  },
  ctr: {
    id: "ctr",
    name: "CTR",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_CTR",
  },
  impressions: {
    id: "impressions",
    name: "Impressions",
    type: "count_whole",
    kind: "metric",
    messageId: "LABEL_IMPRESSIONS",
  },
  measurement_cost: {
    id: "measurement_cost",
    name: "Measurement Cost",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MEASUREMENT_COST",
  },
  media_cost: {
    id: "media_cost",
    name: "Media Cost",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MEDIA_COST",
  },
  media_cost_cpa: {
    id: "media_cost_cpa",
    name: "Media Cost eCPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MEDIA_COST_CPA",
  },
  media_cost_cpc: {
    id: "media_cost_cpc",
    name: "Media Cost eCPC",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MEDIA_COST_CPC",
  },
  media_cost_cpcv: {
    id: "media_cost_cpcv",
    name: "Media Cost eCPCV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MEDIA_COST_CPCV",
  },
  media_cost_cpm: {
    id: "media_cost_cpm",
    name: "Media Cost eCPM",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MEDIA_COST_CPM",
  },
  media_cost_pc_cpa: {
    id: "media_cost_pc_cpa",
    name: "Media Cost PC CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MEDIA_COST_PC_CPA",
  },
  media_cost_pv_cpa: {
    id: "media_cost_pv_cpa",
    name: "Media Cost PV CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MEDIA_COST_PV_CPA",
  },
  media_cost_roi: {
    id: "media_cost_roi",
    name: "Media Cost ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_MEDIA_COST_ROI",
  },
  mm_data_cost: {
    id: "mm_data_cost",
    name: "Data Cost",
    type: "money",
    kind: "metric",
    messageId: "LABEL_MM_DATA_COST",
  },
  optimization_fee: {
    id: "optimization_fee",
    name: "DBA Fee",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OPTIMIZATION_FEE",
  },
  offline_aov: {
    id: "offline_aov",
    name: "Offline AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_AOV",
  },
  offline_order_cpa: {
    id: "offline_order_cpa",
    name: "Offline CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_CPA",
  },
  offline_orders: {
    id: "offline_orders",
    name: "Offline Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_OFFLINE_CONVERSIONS",
  },
  offline_post_click_aov: {
    id: "offline_post_click_aov",
    name: "Post Click Offline AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_OFFLINE_AOV",
  },
  offline_post_click_orders: {
    id: "offline_post_click_orders",
    name: "Offline Post Click Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_CLICK_CONVERSIONS",
  },
  offline_post_click_order_cpa: {
    id: "offline_post_click_order_cpa",
    name: "Offline Post Click CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_CLICK_CPA",
  },
  offline_post_click_units: {
    id: "offline_post_click_units",
    name: "Offline Post Click Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_CLICK_UNITS",
  },
  offline_post_click_units_cpa: {
    id: "offline_post_click_units_cpa",
    name: "Offline Post Click Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_CLICK_UNIT_CPA",
  },
  offline_post_view_aov: {
    id: "offline_post_view_aov",
    name: "Post View Offline AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_OFFLINE_AOV",
  },
  offline_post_view_conversions: {
    id: "offline_post_view_conversions",
    name: "Offline Post View Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_VIEW_CONVERSIONS",
  },
  offline_post_view_order_cpa: {
    id: "offline_post_view_order_cpa",
    name: "Offline Post View CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_VIEW_CPA",
  },
  offline_post_view_orders: {
    id: "offline_post_view_orders",
    name: "Offline Post View Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_VIEW_CONVERSIONS",
  },
  offline_post_view_units_cpa: {
    id: "offline_post_view_units_cpa",
    name: "Offline Post View Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_VIEW_UNIT_CPA",
  },
  offline_post_click_product_revenue: {
    id: "offline_post_click_product_revenue",
    name: "Offline Post Click Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_CLICK_REVENUE",
  },
  offline_post_click_roi: {
    id: "offline_post_click_roi",
    name: "Offline Post Click ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_CLICK_ROI",
  },
  offline_post_view_product_revenue: {
    id: "offline_post_view_product_revenue",
    name: "Offline Post View Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_VIEW_REVENUE",
  },
  offline_post_view_roi: {
    id: "offline_post_view_roi",
    name: "Offline Post View ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_VIEW_ROI",
  },
  offline_post_view_units: {
    id: "offline_post_view_units",
    name: "Offline Post View Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_OFFLINE_POST_VIEW_UNITS",
  },
  offline_product_revenue: {
    id: "offline_product_revenue",
    name: "Offline Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_REVENUE",
  },
  offline_roi: {
    id: "offline_roi",
    name: "Offline ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_OFFLINE_ROI",
  },
  offline_units: {
    id: "offline_units",
    name: "Offline Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_OFFLINE_UNITS",
  },
  offline_units_cpa: {
    id: "offline_units_cpa",
    name: "Offline Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_OFFLINE_UNIT_CPA",
  },
  online_aov: {
    id: "online_aov",
    name: "Online AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_AOV",
  },
  online_order_cpa: {
    id: "online_order_cpa",
    name: "Online CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_CPA",
  },
  online_orders: {
    id: "online_orders",
    name: "Online Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_CONVERSIONS",
  },
  online_post_click_aov: {
    id: "online_post_click_aov",
    name: "Post Click Online AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_ONLINE_AOV",
  },
  online_post_click_conversions: {
    id: "online_post_click_conversions",
    name: "Online Post Click Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_CONVERSIONS",
  },
  online_post_click_orders: {
    id: "online_post_click_orders",
    name: "Online Post Click Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_CONVERSIONS",
  },
  online_post_click_order_cpa: {
    id: "online_post_click_order_cpa",
    name: "Online Post Click CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_CPA",
  },
  online_post_click_product_revenue: {
    id: "online_post_click_product_revenue",
    name: "Online Post Click Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_REVENUE",
  },
  online_post_click_revenue: {
    id: "online_post_click_revenue",
    name: "Online Post Click Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_REVENUE",
  },
  online_post_click_roi: {
    id: "online_post_click_roi",
    name: "Online Post Click ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_ROI",
  },
  online_post_click_units: {
    id: "online_post_click_units",
    name: "Online Post Click Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_UNITS",
  },
  online_post_click_units_cpa: {
    id: "online_post_click_units_cpa",
    name: "Online Post Click Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_UNIT_CPA",
  },
  online_post_view_aov: {
    id: "online_post_view_aov",
    name: "Post View Online AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_ONLINE_AOV",
  },
  online_post_view_conversions: {
    id: "online_post_view_conversions",
    name: "Online Post View Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_CONVERSIONS",
  },
  online_post_view_order_cpa: {
    id: "online_post_view_order_cpa",
    name: "Online Post View CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_CPA",
  },
  online_post_view_orders: {
    id: "online_post_view_orders",
    name: "Online Post View Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_CONVERSIONS",
  },
  online_post_view_product_revenue: {
    id: "online_post_view_product_revenue",
    name: "Online Post View Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_REVENUE",
  },
  online_post_view_revenue: {
    id: "online_post_view_revenue",
    name: "Online Post View Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_REVENUE",
  },
  online_post_view_roi: {
    id: "online_post_view_roi",
    name: "Online Post View ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_ROI",
  },
  online_post_view_units: {
    id: "online_post_view_units",
    name: "Online Post View Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_UNITS",
  },
  online_post_view_units_cpa: {
    id: "online_post_view_units_cpa",
    name: "Online Post View Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_UNIT_CPA",
  },
  online_product_revenue: {
    id: "online_product_revenue",
    name: "Online Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_REVENUE",
  },
  online_roi: {
    id: "online_roi",
    name: "Online ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_ONLINE_ROI",
  },
  online_units: {
    id: "online_units",
    name: "Online Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_UNITS",
  },
  online_units_cpa: {
    id: "online_units_cpa",
    name: "Online Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ONLINE_UNIT_CPA",
  },
  order_rate: {
    id: "order_rate",
    name: "Conversion Rate",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_CONVERSION_RATE",
  },
  post_click_aov: {
    id: "post_click_aov",
    name: "Post Click AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_AOV",
  },
  post_click_conversions: {
    id: "post_click_conversions",
    name: "Post Click Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_CONVERSIONS",
  },
  post_click_orders: {
    id: "post_click_orders",
    name: "Post Click Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_CONVERSIONS",
  },
  post_click_order_cpa: {
    id: "post_click_order_cpa",
    name: "Post Click CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_CPA",
  },
  post_click_media_cost_roi: {
    id: "post_click_media_cost_roi",
    name: "Post Click Media Cost ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_MEDIA_COST_ROI",
  },
  post_click_product_revenue: {
    id: "post_click_product_revenue",
    name: "Post Click Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_REVENUE",
  },
  post_click_revenue: {
    id: "post_click_revenue",
    name: "Post Click Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_REVENUE",
  },
  post_click_roi: {
    id: "post_click_roi",
    name: "Post Click ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_ROI",
  },
  post_click_total_ad_cost_roi: {
    id: "post_click_total_ad_cost_roi",
    name: "Post Click Total Ad Cost ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_TOTAL_AD_COST_ROI",
  },
  post_click_total_spend_roi: {
    id: "post_click_total_spend_roi",
    name: "Post Click Total Spend ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_TOTAL_SPEND_ROI",
  },
  post_click_units: {
    id: "post_click_units",
    name: "Post Click Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_UNITS",
  },
  post_click_units_cpa: {
    id: "post_click_units_cpa",
    name: "Post Click Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_UNIT_CPA",
  },
  post_view_aov: {
    id: "post_view_aov",
    name: "Post View AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_AOV",
  },
  post_view_conversions: {
    id: "post_view_conversions",
    name: "Post View Conversions",
    type: "float",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_CONVERSIONS",
  },
  post_view_conversions_raw: {
    id: "post_view_conversions_raw",
    name: "Post View Conversions (Raw)",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_CONVERSIONS_RAW",
  },
  post_view_media_cost_roi: {
    id: "post_view_media_cost_roi",
    name: "Post View Media Cost ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_MEDIA_COST_ROI",
  },
  post_view_orders: {
    id: "post_view_orders",
    name: "Post View Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_CONVERSIONS",
  },
  post_view_order_cpa: {
    id: "post_view_order_cpa",
    name: "Post View CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_CPA",
  },
  post_view_product_revenue: {
    id: "post_view_product_revenue",
    name: "Post View Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_REVENUE",
  },
  post_view_revenue: {
    id: "post_view_revenue",
    name: "Post View Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_REVENUE",
  },
  post_view_revenue_raw: {
    id: "post_view_revenue_raw",
    name: "Post View Revenue (Raw)",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_REVENUE_RAW",
  },
  post_view_roi: {
    id: "post_view_roi",
    name: "Post View ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_ROI",
  },
  post_view_total_ad_cost_roi: {
    id: "post_view_total_ad_cost_roi",
    name: "Post View Total Ad Cost ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_TOTAL_AD_COST_ROI",
  },
  post_view_total_spend_roi: {
    id: "post_view_total_spend_roi",
    name: "Post View Total Spend ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_TOTAL_SPEND_ROI",
  },
  post_view_units: {
    id: "post_view_units",
    name: "Post View Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_UNITS",
  },
  post_view_units_cpa: {
    id: "post_view_units_cpa",
    name: "Post View Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_UNIT_CPA",
  },
  revenue_raw: {
    id: "revenue_raw",
    name: "Revenue (Raw)",
    type: "money",
    kind: "metric",
    messageId: "LABEL_REVENUE_RAW",
  },
  rr_per_1k_imps: {
    id: "rr_per_1k_imps",
    name: "Response Rate/1K Imps",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_RR_PER_1K_IMPS",
  },
  total_ad_cost: {
    id: "total_ad_cost",
    name: "Total Ad Cost",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_AD_COST",
  },
  total_ad_cost_cpa: {
    id: "total_ad_cost_cpa",
    name: "Total Ad Cost eCPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_AD_COST_CPA",
  },
  total_ad_cost_cpc: {
    id: "total_ad_cost_cpc",
    name: "Total Ad Cost eCPC",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_AD_COST_CPC",
  },
  total_ad_cost_cpcv: {
    id: "total_ad_cost_cpcv",
    name: "Total Ad Cost eCPCV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_AD_COST_CPCV",
  },
  total_ad_cost_cpm: {
    id: "total_ad_cost_cpm",
    name: "Total Ad Cost eCPM",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_AD_COST_CPM",
  },
  total_ad_cost_pc_cpa: {
    id: "total_ad_cost_pc_cpa",
    name: "Total Ad Cost PC CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_AD_COST_PC_CPA",
  },
  total_ad_cost_pv_cpa: {
    id: "total_ad_cost_pv_cpa",
    name: "Total Ad Cost PV CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_AD_COST_PV_CPA",
  },
  total_ad_cost_roi: {
    id: "total_ad_cost_roi",
    name: "Total Ad Cost ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_AD_COST_ROI",
  },
  total_aov: {
    id: "total_aov",
    name: "Total AOV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_AOV",
  },
  total_conversions: {
    id: "total_conversions",
    name: "Total Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_CONVERSIONS",
  },
  total_offline_conversions: {
    id: "total_offline_conversions",
    name: "Total Offline Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_OFFLINE_CONVERSIONS",
  },
  total_offline_post_click_conversions: {
    id: "total_offline_post_click_conversions",
    name: "Total Offline Post Click Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_OFFLINE_POST_CLICK_CONVERSIONS",
  },
  total_offline_post_click_revenue: {
    id: "total_offline_post_click_revenue",
    name: "Total Offline Post Click Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_OFFLINE_POST_CLICK_REVENUE",
  },
  total_offline_post_view_conversions: {
    id: "total_offline_post_view_conversions",
    name: "Total Offline Post View Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_OFFLINE_POST_VIEW_CONVERSIONS",
  },
  total_offline_post_view_revenue: {
    id: "total_offline_post_view_revenue",
    name: "Total Offline Post View Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_OFFLINE_POST_VIEW_REVENUE",
  },
  total_offline_revenue: {
    id: "total_offline_revenue",
    name: "Total Offline Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_OFFLINE_REVENUE",
  },
  total_online_conversions: {
    id: "total_online_conversions",
    name: "Online Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_CONVERSIONS",
  },
  total_online_post_click_conversions: {
    id: "total_online_post_click_conversions",
    name: "Online Post Click Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_CLICK_CONVERSIONS",
  },
  total_online_post_view_conversions: {
    id: "total_online_post_view_conversions",
    name: "Online Post View Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_ONLINE_POST_VIEW_CONVERSIONS",
  },
  total_online_revenue: {
    id: "total_online_revenue",
    name: "Total Online Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_ONLINE_REVENUE",
  },
  total_online_post_click_revenue: {
    id: "total_online_post_click_revenue",
    name: "Total Online Post Click Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_ONLINE_POST_CLICK_REVENUE",
  },
  total_online_post_view_revenue: {
    id: "total_online_post_view_revenue",
    name: "Total Online Post View Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_ONLINE_POST_VIEW_REVENUE",
  },
  total_order_cpa: {
    id: "total_order_cpa",
    name: "Total CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_CPA",
  },
  total_orders: {
    id: "total_orders",
    name: "Total Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_CONVERSIONS",
  },
  total_post_click_conversions: {
    id: "total_post_click_conversions",
    name: "Total Post Click Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_POST_CLICK_CONVERSIONS",
  },
  total_post_click_roi: {
    id: "total_post_click_roi",
    name: "Total Post Click ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_POST_CLICK_ROI",
  },
  total_post_view_conversions: {
    id: "total_post_view_conversions",
    name: "Post View Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_CONVERSIONS",
  },
  total_post_view_revenue: {
    id: "total_post_view_revenue",
    name: "Total Post View Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_POST_VIEW_REVENUE",
  },
  total_post_view_roi: {
    id: "total_post_view_roi",
    name: "Total Post View ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_POST_VIEW_ROI",
  },
  total_post_click_revenue: {
    id: "total_post_click_revenue",
    name: "Total Post Click Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_POST_CLICK_REVENUE",
  },
  total_product_revenue: {
    id: "total_product_revenue",
    name: "Total Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_REVENUE",
  },
  total_revenue: {
    id: "total_revenue",
    name: "Total Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_REVENUE",
  },
  total_roi: {
    id: "total_roi",
    name: "Total ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_ROI",
  },
  total_spend: {
    id: "total_spend",
    name: "Total Spend",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND",
  },
  total_spend_cpa: {
    id: "total_spend_cpa",
    name: "Total Spend eCPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_CPA",
  },
  total_spend_cpc: {
    id: "total_spend_cpc",
    name: "Total Spend eCPC",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_CPC",
  },
  total_spend_cpcv: {
    id: "total_spend_cpcv",
    name: "Total Spend eCPCV",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_CPCV",
  },
  total_spend_cpm: {
    id: "total_spend_cpm",
    name: "Total Spend eCPM",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_CPM",
  },
  total_spend_offline_roi: {
    id: "total_spend_offline_roi",
    name: "Total Spend Offline ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_OFFLINE_ROI",
  },
  total_spend_offline_post_click_roi: {
    id: "total_spend_offline_post_click_roi",
    name: "Total Spend Offline Post Click ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_OFFLINE_POST_CLICK_ROI",
  },
  total_spend_offline_post_view_roi: {
    id: "total_spend_offline_post_view_roi",
    name: "Total Spend Offline Post View ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_OFFLINE_POST_VIEW_ROI",
  },
  total_spend_online_post_click_roi: {
    id: "total_spend_online_post_click_roi",
    name: "Total Spend Online Post Click ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_ONLINE_POST_CLICK_ROI",
  },
  total_spend_online_post_view_roi: {
    id: "total_spend_online_post_view_roi",
    name: "Total Spend Online Post View ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_ONLINE_POST_VIEW_ROI",
  },
  total_spend_pc_cpa: {
    id: "total_spend_pc_cpa",
    name: "Total Spend PC CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_PC_CPA",
  },
  total_spend_post_click_roi: {
    id: "total_spend_post_click_roi",
    name: "Total Spend Post Click ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_POST_CLICK_ROI",
  },
  total_spend_post_view_roi: {
    id: "total_spend_post_view_roi",
    name: "Total Spend Post View ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_POST_VIEW_ROI",
  },
  total_spend_online_roi: {
    id: "total_spend_online_roi",
    name: "Total Spend Online ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_ONLINE_ROI",
  },
  total_spend_pv_cpa: {
    id: "total_spend_pv_cpa",
    name: "Total Spend PV CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_PV_CPA",
  },
  total_spend_roi: {
    id: "total_spend_roi",
    name: "Total Spend ROI",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_TOTAL_SPEND_ROI",
  },
  total_units: {
    id: "total_units",
    name: "Total Units",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_UNITS",
  },
  total_units_cpa: {
    id: "total_units_cpa",
    name: "Unit CPA",
    type: "money",
    kind: "metric",
    messageId: "LABEL_UNIT_CPA",
  },
  video_close: {
    id: "video_close",
    name: "Close",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_CLOSE",
  },
  video_collapse: {
    id: "video_collapse",
    name: "Collapse",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_COLLAPSE",
  },
  video_companion_clicks: {
    id: "video_companion_clicks",
    name: "Companion Clicks",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_COMPANION_CLICKS",
  },
  video_companion_ctr: {
    id: "video_companion_ctr",
    name: "Companion CTR",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_COMPANION_CTR",
  },
  video_companion_impressions: {
    id: "video_companion_impressions",
    name: "Companion Impressions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_COMPANION_IMPRESSIONS",
  },
  video_complete: {
    id: "video_complete",
    name: "100% Completed Views",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_COMPLETE",
  },
  video_complete_rate: {
    id: "video_complete_rate",
    name: "100% Completed Rate",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_COMPLETE_RATE",
  },
  video_complete_rate_impression_based: {
    id: "video_complete_rate_impression_based",
    name: "VCR (Impression Based)",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_COMPLETE_RATE_IMPRESSION_BASED",
  },
  video_engaged_impressions: {
    id: "video_engaged_impressions",
    name: "Engaged Impressions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_ENGAGED_IMPRESSIONS",
  },
  video_engaged_rate: {
    id: "video_engaged_rate",
    name: "Engaged Rate",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_ENGAGED_RATE",
  },
  video_expand: {
    id: "video_expand",
    name: "Expand",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_EXPAND",
  },
  video_first_quartile: {
    id: "video_first_quartile",
    name: "25% Completed Views",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_FIRST_QUARTILE",
  },
  video_first_quartile_rate: {
    id: "video_first_quartile_rate",
    name: "25% Completed Rate",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_FIRST_QUARTILE_RATE",
  },
  video_first_quartile_rate_impression_based: {
    id: "video_first_quartile_rate_impression_based",
    name: "25% Completed Rate - Impressions Based",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_FIRST_QUARTILE_RATE_IMPRESSION_BASED",
  },
  video_fullscreen: {
    id: "video_fullscreen",
    name: "Fullscreen",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_FULLSCREEN",
  },
  video_midpoint: {
    id: "video_midpoint",
    name: "50% Completed Views",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_MIDPOINT",
  },
  video_midpoint_rate: {
    id: "video_midpoint_rate",
    name: "50% Completed Rate",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_MIDPOINT_RATE",
  },
  video_midpoint_rate_impression_based: {
    id: "video_midpoint_rate_impression_based",
    name: "50% Completed Rate - Impressions Based",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_MIDPOINT_RATE_IMPRESSION_BASED",
  },
  video_mute: {
    id: "video_mute",
    name: "Mute",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_MUTE",
  },
  video_pause: {
    id: "video_pause",
    name: "Pause",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_PAUSE",
  },
  video_play_rate: {
    id: "video_play_rate",
    name: "Play Rate",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_PLAY_RATE",
  },
  video_resume: {
    id: "video_resume",
    name: "Resume",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_RESUME",
  },
  video_rewind: {
    id: "video_rewind",
    name: "Rewind",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_REWIND",
  },
  video_skip: {
    id: "video_skip",
    name: "Skip",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_SKIP",
  },
  video_skippable_impressions: {
    id: "video_skippable_impressions",
    name: "Skippable Impressions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_SKIPPABLE_IMPRESSIONS",
  },
  video_skipped_impressions: {
    id: "video_skipped_impressions",
    name: "Skipped Impressions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_SKIPPED_IMPRESSIONS",
  },
  video_skipped_rate: {
    id: "video_skipped_rate",
    name: "Skipped Rate",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_SKIPPED_RATE",
  },
  video_start: {
    id: "video_start",
    name: "Start",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_START",
  },
  video_third_quartile: {
    id: "video_third_quartile",
    name: "75% Completed Views",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_THIRD_QUARTILE",
  },
  video_third_quartile_rate: {
    id: "video_third_quartile_rate",
    name: "75% Completed Rate",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_THIRD_QUARTILE_RATE",
  },
  video_third_quartile_rate_impression_based: {
    id: "video_third_quartile_rate_impression_based",
    name: "75% Completed Rate - Impressions Based",
    type: "percent",
    kind: "metric",
    messageId: "LABEL_VIDEO_THIRD_QUARTILE_RATE_IMPRESSION_BASED",
  },
  video_unmute: {
    id: "video_unmute",
    name: "Unmute",
    type: "count",
    kind: "metric",
    messageId: "LABEL_VIDEO_UNMUTE",
  },
  total_unique_converters: {
    id: "total_unique_converters",
    name: "Total Unique Converters",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_UNIQUE_CONVERTERS",
  },
  total_conversions_revenue: {
    id: "total_conversions_revenue",
    name: "Total Conversions Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_CONVERSIONS_REVENUE",
  },
  total_ntb_conversions: {
    id: "total_ntb_conversions",
    name: "Total New to Brand Conversions",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_NTB_CONVERSIONS",
  },
  total_ntb_converters: {
    id: "total_ntb_converters",
    name: "Total New to Brand Converters",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_NTB_CONVERTERS",
  },
  total_ntb_revenue: {
    id: "total_ntb_revenue",
    name: "Total New to Brand Revenue",
    type: "money",
    kind: "metric",
    messageId: "LABEL_TOTAL_NTB_REVENUE",
  },
  incremental_roas: {
    id: "incremental_roas",
    name: "Incremental ROAS",
    type: "count",
    kind: "metric",
    messageId: "LABEL_INCREMENTAL_ROAS",
  },
  total_atc: {
    id: "total_atc",
    name: "Total ATC",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_ATC",
  },
  total_ppv: {
    id: "total_ppv",
    name: "Total PPV",
    type: "count",
    kind: "metric",
    messageId: "LABEL_TOTAL_PPV",
  },
  cart_to_purchase_rate: {
    id: "cart_to_purchase_rate",
    name: "Cart to Purchase Rate",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_CART_TO_PURCHASE_RATE",
  },
  abandonment_rate: {
    id: "abandonment_rate",
    name: "Abandonment Rate",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_ABANDONMENT_RATE",
  },
  atc_cost: {
    id: "atc_cost",
    name: "ATC Cost",
    type: "money",
    kind: "metric",
    messageId: "LABEL_ATC_COST",
  },
  post_click_atc: {
    id: "post_click_atc",
    name: "Post Click ATC",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_ATC",
  },
  post_view_atc: {
    id: "post_view_atc",
    name: "Post View ATC",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_ATC",
  },
  post_click_ppv: {
    id: "post_click_ppv",
    name: "Post Click PPV",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_PPV",
  },
  post_view_ppv: {
    id: "post_view_ppv",
    name: "Post View PPV",
    type: "count",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_PPV",
  },
  post_click_abandonment_rate: {
    id: "post_click_abandonment_rate",
    name: "Post Click Abandonment Rate",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_ABANDONMENT_RATE",
  },
  post_view_abandonment_rate: {
    id: "post_view_abandonment_rate",
    name: "Post View Abandonment Rate",
    type: "ratio",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_ABANDONMENT_RATE",
  },
  post_click_atc_cost: {
    id: "post_click_atc_cost",
    name: "Post Click ATC Cost",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_CLICK_ATC_COST",
  },
  post_view_atc_cost: {
    id: "post_view_atc_cost",
    name: "Post View ATC Cost",
    type: "money",
    kind: "metric",
    messageId: "LABEL_POST_VIEW_ATC_COST",
  },
};
